import { render } from "./SingleLeagueView.vue?vue&type=template&id=4007b9a4&scoped=true"
import script from "./SingleLeagueView.vue?vue&type=script&lang=js"
export * from "./SingleLeagueView.vue?vue&type=script&lang=js"

import "./SingleLeagueView.vue?vue&type=style&index=0&id=4007b9a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4007b9a4"]])

export default __exports__